import { render, staticRenderFns } from "./PatrolReminder.vue?vue&type=template&id=67bf1021&scoped=true"
import script from "./PatrolReminder.vue?vue&type=script&lang=js"
export * from "./PatrolReminder.vue?vue&type=script&lang=js"
import style0 from "./PatrolReminder.vue?vue&type=style&index=0&id=67bf1021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf1021",
  null
  
)

export default component.exports